import React, { useState, useEffect } from 'react';
import { Modal, Button } from '../../components/ds';
import api from '../../api/client';

export default function AddDelegationModal({ accountId, onClose, onAdded }) {
  const [companies, setCompanies] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAvailable = async () => {
      try {
        const [allCompanies, delegations] = await Promise.all([
          api.getCompanies(),
          api.getDelegations(),
        ]);

        const delegatedIds = new Set(
          (delegations || []).map((d) => d.delegatee_id)
        );

        const available = (allCompanies || []).filter(
          (c) => !delegatedIds.has(c.uuid)
        );

        setCompanies(available);
      } catch (err) {
        setError('Failed to load companies: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAvailable();
  }, []);

  const handleSubmit = async () => {
    if (!selected) return;
    setSubmitting(true);
    setError('');

    try {
      await api.createDelegation({
        delegatee_id: selected,
        delegator_id: accountId,
      });
      onAdded();
    } catch (err) {
      setError('Failed to create delegation: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal title="Add Delegation" onClose={onClose} footer={
      <>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!selected || submitting}>
          {submitting ? 'Adding...' : 'Confirm'}
        </Button>
      </>
    }>
      {loading ? (
        <div className="loading">Loading companies...</div>
      ) : companies.length === 0 ? (
        <p style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: 20 }}>
          No available companies to delegate
        </p>
      ) : (
        <>
          <p style={{ marginBottom: 12, color: 'var(--text-secondary)', fontSize: 14 }}>
            Select a company to delegate to this account:
          </p>
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {companies.map((company) => (
              <label
                key={company.uuid}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '10px 12px',
                  borderRadius: 'var(--radius-md)',
                  cursor: 'pointer',
                  border: selected === company.uuid
                    ? '2px solid var(--primary-orange)'
                    : '1px solid var(--border-color)',
                  marginBottom: 8,
                  backgroundColor: selected === company.uuid ? 'var(--bg-secondary)' : 'transparent',
                }}
              >
                <input
                  type="radio"
                  name="company"
                  checked={selected === company.uuid}
                  onChange={() => setSelected(company.uuid)}
                />
                <span style={{ fontWeight: 500 }}>{company.company_name}</span>
              </label>
            ))}
          </div>
        </>
      )}

      {error && <div className="error-text">{error}</div>}
    </Modal>
  );
}
